export function removeCookie(name: string): void {
    if (typeof document === 'undefined') return;

    // Устанавливаем куку с прошедшей датой expiry, чтобы браузер удалил её
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}
